import { ProgramFlex, ProgramStack, useProgram } from 'planby'
import { ProgramItem } from 'planby/dist/Epg/helpers/types'
import { getPlacement, TIME_FORMAT } from '../../helpers'
import { getColorFromSport } from '../../helpers/sports'
import { getLinkUrlFromSport } from '../../helpers/sportsUrlData'
import {
    StyledEmptyProgramContent,
    StyledLiveText,
    StyledProgramBox,
    StyledProgramContent,
    StyledProgramDescription,
    StyledProgramFillerTitle,
    StyledProgramTime,
    StyledProgramTitle,
} from './ChannelProgram.styled'
import { isPast } from 'date-fns'

type ChannelProgramProps = {
    program: ProgramItem
    isBaseTimeFormat: boolean
    onClick: () => void
}

export const ChannelProgram = ({ program, onClick, isBaseTimeFormat }: ChannelProgramProps) => {
    const { styles, formatTime, isLive } = useProgram({
        program,
        isBaseTimeFormat,
    })

    const { data } = program
    const { title, since, till, description } = data

    const handleItemClick = () => {
        onClick()
    }

    const timeFormat = isBaseTimeFormat ? TIME_FORMAT.BASE_HOURS_TIME : TIME_FORMAT.HOURS_MIN

    const formattedDescription = description.replaceAll('\n', ' | ')

    return (
        <StyledProgramBox width={styles.width} style={styles.position} title={formattedDescription}>
            {title === 'filler' ? (
                <StyledEmptyProgramContent>
                    <StyledProgramFillerTitle>Event Ended</StyledProgramFillerTitle>
                </StyledEmptyProgramContent>
            ) : (
                <a
                    href={getLinkUrlFromSport(program.data.channelUuid, getPlacement())}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <StyledProgramContent
                        width={styles.width}
                        isLive={isLive}
                        onClick={handleItemClick}
                        isEnded={isPast(new Date(till))}
                        backgroundColor={getColorFromSport(program.data.channelUuid)}
                    >
                        <ProgramFlex>
                            <ProgramStack>
                                <StyledProgramTitle>{title}</StyledProgramTitle>
                                {isLive && (
                                    <StyledLiveText
                                        style={{ color: getColorFromSport(program.data.channelUuid) }}
                                    >
                                        ON NOW{' '}
                                    </StyledLiveText>
                                )}
                                <StyledProgramTime>
                                    {formatTime(since, timeFormat).replace('AM', '').replace('PM', '')}-
                                    {formatTime(till, timeFormat)}
                                </StyledProgramTime>
                                <StyledProgramDescription>{formattedDescription}</StyledProgramDescription>
                            </ProgramStack>
                        </ProgramFlex>
                    </StyledProgramContent>
                </a>
            )}
        </StyledProgramBox>
    )
}
